/* eslint-disable react/jsx-props-no-spreading */

import {
    Typography,
} from '@mui/material'
import PropTypes from 'prop-types'
import {
    useTheme,
} from '@mui/material/styles'

import useStyles from './ChipSelect.style'

const propTypes = {
    innerProps: PropTypes.objectOf(PropTypes.func),
    children: PropTypes.string,
}

const defaultProps = {
    children: '',
    innerProps: {},
}

function Placeholder(props) {
    const {
        innerProps,
        children,
    } = props

    const theme = useTheme()
    const {
        classes,
    } = useStyles(theme)

    return (
        <Typography
            color="textSecondary"
            className={classes.placeholder}
            {...innerProps}
        >
            {children}
        </Typography>
    )
}

Placeholder.propTypes = propTypes
Placeholder.defaultProps = defaultProps

export default Placeholder
